import { types } from "../../types/types";
import { fetchConToken } from "../../helpers/fetch";
import { startAlerta } from "../ui/alertas";
import { startSpinner, finishSpinner } from "../ui/spinner";
import { fileUploadPaymentFile } from "../../helpers/fileUpload";
import { propuestaFacturacionEliminar } from "./propuestaFacturacion";

export const facturasAfiliadoTraerStart = () => ({
  type: types.facturasAfiliadoTraerStart,
});
export const facturasAfiliadoLimpiar = () => ({
  type: types.facturasAfiliadoLimpiar,
});
export const facturasAfiliadoTraerError = (error) => ({
  type: types.facturasAfiliadoTraerError,
  payload: error,
});
export const facturasAfiliadoSeleccionado = (payload) => ({
  type: types.facturasAfiliadoSeleccionado,
  payload: payload,
});
export const facturasAfiliadoSeleccionadoLimpiar = (payload) => ({
  type: types.facturasAfiliadoSeleccionadoLimpiar,
});
export const facturasAfiliadoModificar = (payload) => ({
  type: types.facturasAfiliadoModificar,
  payload: payload,
});
export const facturasAfiliadoEliminar = (payload) => ({
  type: types.facturasAfiliadoEliminar,
  payload: payload,
});
export const facturasAfiliadoTraerSuccess = (payload) => {
  return {
    type: types.facturasAfiliadoTraerSuccess,
    payload: payload,
  };
};
export const facturasAfiliadoDetalleSeleccionadoTraerSuccess = (payload) => {
  return {
    type: types.facturasAfiliadoDetalleSeleccionadoTraerSuccess,
    payload: payload,
  };
};

export const fetchCtaCtePorAfiliado = (idAfiliado) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      dispatch(facturasAfiliadoTraerStart());
      const response = await fetchConToken(
        `BeneficiariosFacturas/traerCtaCtePorAfiliado/${idAfiliado}`
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch(facturasAfiliadoTraerSuccess(lista));
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const fetchDetalleCompSeleccionado = (compSeleccionado) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      dispatch(facturasAfiliadoTraerStart());
      dispatch(facturasAfiliadoSeleccionado(compSeleccionado));
      const parametros = `idAfiliado=${compSeleccionado.idAfiliado}&idTipoComprobante2=${compSeleccionado.idTipoComprobante2}&nroComprobante2=${compSeleccionado.nroComprobante2}&fechaComprobante2=${compSeleccionado.fechaComprobante2}&nroComprobante=${compSeleccionado.nroComprobante}`;
      const response = await fetchConToken(`BeneficiariosFacturas/traerDetalleComprobante?${parametros}`);
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        if (response.status !== 200) throw lista.errores;
        dispatch(facturasAfiliadoDetalleSeleccionadoTraerSuccess(lista));
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const fetchCuponPago = (comprobante) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const parametros = `idAfiliado=${comprobante.idAfiliado}&idTipoComprobante=${comprobante.idTipoComprobante}&nroComprobante=${comprobante.nroComprobante}&fechaComprobante=${comprobante.fechaComprobante}`;
      const response = await fetchConToken(
        `BeneficiariosFacturas/traerIdCuponPago?${parametros}`
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const resp = await response.json();
        if (response.status !== 200) throw resp.errores;
        dispatch(generatePdfCuponPago(resp));
      }
    } catch (err) {
      console.log(err);
      dispatch(finishSpinner());
      dispatch(
        startAlerta(
          "Ocurrio un error en la generación del PDF",
          "warning",
          `¡Error!`
        )
      );
    }
  };
};

export const generatePdfCuponPago = (idCuponPago) => {
  return async (dispatch) => {
    try {
      const baseUrlReport = process.env.REACT_APP_REPORT_API_URL;
      const url = `${baseUrlReport}/Reportes/GenerateCuponPagoPdf/${idCuponPago}`;
      const response = await fetch(url);
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/pdf") !== -1) {
        const blob = await response.blob();
        if (response.status !== 200) throw blob.errores;

        window.open(URL.createObjectURL(blob));
      }
      dispatch(finishSpinner());
    } catch (err) {
      console.log(err);
      dispatch(finishSpinner());
      dispatch(
        startAlerta(
          "Ocurrio un error en la generación del PDF",
          "warning",
          `¡Error!`
        )
      );
    }
  };
};

export const generarFacturaAfiliados = (jsonData, idTipoComprobante, idObservacion, selectedAfi, callback) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await fetchConToken(
        `BeneficiariosFacturas/generar`,
        { jsonData, idTipoComprobante, idObservacion, callback },
        "POST"
      );
      const contentType = response.headers.get("content-type");

      if (contentType && contentType.indexOf("application/json") !== -1) {
        const resp = await response.json();
        if (response.status !== 200) throw resp.errores;
        dispatch( startAlerta(`Las Facturas se generaron correctamente`, "success", `Exito!`) );
        dispatch( propuestaFacturacionEliminar(selectedAfi) );
        callback&& callback();
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const anularFacturaAfiliado = (idAfiliado, idTipoComprobante, nroComprobante, fechaComprobante, observacion) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await fetchConToken(
        `BeneficiariosFacturas/anular`,
        { idAfiliado, idTipoComprobante, nroComprobante, fechaComprobante, observacion },
        "POST"
      );
      const contentType = response.headers.get("content-type");

      if (contentType && contentType.indexOf("application/json") !== -1) {
        const resp = await response.json();
        if (response.status !== 200) throw resp.errores;
        dispatch( startAlerta(`La Factura ${nroComprobante} se anulo correctamente`, "success", `Exito!`) );
        // dispatch( propuestaFacturacionEliminar(selectedAfi) );
        dispatch( fetchCtaCtePorAfiliado(idAfiliado) );
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err, "warning", `¡Error!`));
    }
  };
};

export const startUploadingPaymentFile = (file) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      await fileUploadPaymentFile(file);

      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      dispatch(startAlerta(err.errores.mensaje, "warning", `¡Error!`));
    }
  };
};

export const fetchConsultaFacturacionAfiliado = (idCupon, handlePrint) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await fetchConToken(
        `ConsultasFacturacionAfiliados/${idCupon}`
      );
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const resp = await response.json();
        if (response.status !== 200) throw resp.errores;
        dispatch({
          type: types.facturasAfiliadoConsultaSuccess,
          payload: resp,
        });
        handlePrint();
      }
      dispatch(finishSpinner());
    } catch (err) {
      console.log(err);
      dispatch(finishSpinner());
      dispatch({
        type: types.facturasAfiliadoConsultaError,
      });
      dispatch(
        startAlerta(
          "Ocurrio un error consultando los datos del afiliado",
          "warning",
          `¡Error!`
        )
      );
    }
  };
};
